<template>
  <div class="home_page">
    <!-- <el-header class="right-menu-name" height="20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header> -->
    <div class="tabs">
      <div
        v-for="item in tabList"
        :key="item.key"
        :class="
          's2b-tab-item ' + (item.key === activited ? 'tab-item-active' : '')
        "
      >
        {{ item.lable }} {{ item.count > 0 ? '(' + item.count + ')' : '' }}
      </div>
    </div>
    <div class="shopping-cart">
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%; max-width: 100%;"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="img"
          label=""
          header-align="center"
          align="center"
          width="140"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.fileUrls"
              v-show="scope.row.fileUrls"
              alt=""
              width="100px"
              height="100px"
            />
            <img
              src="~@/assets/img/bitmap.png"
              v-show="!scope.row.fileUrls"
              alt=""
              width="100px"
              height="100px"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span class="goodsName" @click="goodDetail(scope.row)">{{
              scope.row.goodsName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          label="型号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="model"
          label="单价"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div >
              <div
                v-if="
                  scope.row.activityType &&
                    (scope.row.activityType == 1 || scope.row.activityType == 2)
                "
              >
                <span>￥{{ scope.row.activityPrice | formatePrice }}</span
                ><br />
                <span class="discount"
                  >￥{{ scope.row.sellingPrice | formatePrice }}</span
                >
              </div>
              <div v-else>
                <span>￥{{ scope.row.sellingPrice | formatePrice }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          label="数量"
          header-align="center"
          align="center"
          width="175"
        >
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.goodsNum"
              @change="(val, oldVal) => handleChangeCount(scope.row)"
              :min="1"
              :max="999999999"
              :precision="0"
              size="small"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          label="小计"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.activityType &&
                  (scope.row.activityType == 1 || scope.row.activityType == 2)
              "
            >
              <span
                >￥{{
                  (scope.row.activityPrice * scope.row.goodsNum) | formatePrice
                }}</span
              ><br />
            </div>
            <div v-else>
              <span
                >￥{{
                  (scope.row.sellingPrice * scope.row.goodsNum) | formatePrice
                }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          label="操作"
          header-align="center"
          align="center"
          width="60"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="deleteHandle(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fix">
        <div class="left">
          <el-checkbox
            v-model="allCheck"
            class="check-all"
            :disabled="!dataList.length || dataListLoading"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-button
            type="text"
            @click="handleDeleteChoosed()"
            :disabled="dataListLoading"
          >
            删除选中商品
          </el-button>
          <el-button
            type="text"
            @click="clearShoppingCart()"
            :disabled="dataListLoading"
          >
            清空购物车
          </el-button>
        </div>
        <div class="div1">
          已选择 <span class="red">&nbsp;{{ selectGoods }}&nbsp;</span> 件商品
        </div>
        <div class="div2">
          <span
            >总价：￥<span class="red">{{
              allMoney | formatePrice
            }}</span></span
          ><br />
          <span class="discount"
            ><!-- 原价： --><span
              >￥{{ allDiscount | formatePrice }}</span
            ></span
          >
        </div>
        <el-button
          class="div3"
          type="primary"
          plain
          :disabled="!dataList.length || dataListLoading"
          @click="settlement"
        >
        结算
        </el-button>
      </div>
      <div>已下架商品</div>
      <el-table
        v-loading="dataListLoading"
        :data="expiredList"
        ref="expiredTable"
        style="width: 100%; max-width: 100%;"
      >
        <el-table-column
          prop="img"
          label=""
          header-align="center"
          align="center"
          width="140"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.fileUrls"
              v-show="scope.row.fileUrls || ''"
              alt=""
              width="100px"
              height="100px"
            />
            <img
              src="~@/assets/img/bitmap.png"
              v-show="!scope.row.fileUrls"
              alt=""
              width="100px"
              height="100px"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span class="goodsName" @click="goodDetail(scope.row)">{{
              scope.row.goodsName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          label="型号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="model"
          label="单价"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
              <div
                v-if="
                  scope.row.activityType &&
                    (scope.row.activityType == 1 || scope.row.activityType == 2)
                "
              >
                <span>￥{{ scope.row.activityPrice | formatePrice }}</span
                ><br />
                <span class="discount"
                  >￥{{ scope.row.sellingPrice | formatePrice }}</span
                >
              </div>
              <div>
                <span>￥{{ scope.row.sellingPrice | formatePrice }}</span>
              </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsNum"
          label="数量"
          header-align="center"
          align="center"
          width="175"
        >
        </el-table-column>
        <el-table-column
          prop="model"
          label="小计"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.activityType &&
                  (scope.row.activityType == 1 || scope.row.activityType == 2)
              "
            >
              <span
                >￥{{
                  (scope.row.activityPrice * scope.row.goodsNum) | formatePrice
                }}</span
              ><br />
            </div>
            <div v-else>
              <span
                >￥{{
                  (scope.row.sellingPrice * scope.row.goodsNum) | formatePrice
                }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="model"
          label="操作"
          header-align="center"
          align="center"
          width="60"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="deleteHandle(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils'
export default {
  name: 'shopCart', // 购物车
  data () {
    return {
      dataList: [],
      expiredList: [], // 过期商品列表
      dataListLoading: false,
      multipleSelection: [], // 多选数组
      allCheck: false, // 全选
      activited: '1',
      tabList: [
        {
          key: '1',
          lable: '商城',
          count: 0
        }
      ]
    }
  },
  computed: {
    selectGoods () {
      let totalNum = 0
      this.multipleSelection.forEach(item => {
        let row = this.dataList.find(shopItem => {
          return shopItem.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          totalNum += row.goodsNum
        }
      })
      return totalNum // Math.round(totalPrice * 100) / 100
    },
    allMoney () {
      let totalMoney = 0
      this.multipleSelection.forEach(item => {
        let row = this.dataList.find(shopItem => {
          return shopItem.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          if (
            row.activityType &&
            (row.activityType === 1 || row.activityType === 2)
          ) {
            totalMoney += row.activityPrice * row.goodsNum
          } else {
            totalMoney += row.sellingPrice * row.goodsNum
          }
        }
      })
      return Math.round(totalMoney * 100) / 100
    },
    allDiscount () {
      let totalMoney = 0
      this.multipleSelection.forEach(item => {
        let row = this.dataList.find(shopItem => {
          return shopItem.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          totalMoney += row.sellingPrice * row.goodsNum
        }
      })
      return Math.round(totalMoney * 100) / 100
    }
  },
  mounted () {
    this.getDataList()
    this.getShopCartCount()
  },
  methods: {
    // 获取购物车各个类型数量接口
    getShopCartCount () {
      this.tabList.forEach(item => {
        item.count = 0
      })
      this.$request
        .get(`/front/consumer/shoppingcart/queryShoppingCartList`)
        .then(data => {
          if (data) {
            this.tabList[0].count = data.punchoutCount || 0
          } else {
            this.tabList.forEach(item => {
              item.count = 0
            })
          }
        })
        .catch(() => {
          this.tabList.forEach(item => {
            item.count = 0
          })
        })
    },
    // 获取当前用户的购物车列表
    getDataList () {
      this.multipleSelection = []
      this.allCheck = false
      this.dataListLoading = true
      this.$request
        .get(
          `/front/consumer/shoppingcart/myShoppingCartList/5`
        )
        .then(data => {
          this.dataList = data.available || []
          this.expiredList = data.unavailable || []
        })
        .catch(() => {
          this.dataList = []
          this.expiredList = []
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    goodDetail (goods) {
      openOther(
        `punchout-goods-detail?spuId=${goods.goodsSpuId}&skuId=${goods.goodsSkuId}`
      )
    },
    // 表格多选
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === this.dataList.length && val.length) {
        this.allCheck = true
      } else {
        this.allCheck = false
      }
    },
    // 底部全选
    handleCheckAllChange (val) {
      if (val) {
        this.$refs.multipleTable.toggleAllSelection()
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 更改购物车数量
    handleChangeCount (row) {
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http
        .post(`/front/consumer/shoppingcart/updateShoppingCart`, {
          shoppingCartId: row.shoppingCartId,
          goodsNum: row.goodsNum
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.getDataList()
            return false
          }
          // this.getShopCartCount()
          // this.bus.$emit('shopCartNum')
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 删除一行数据
    deleteHandle (row) {
      this.deleteShoppingCartGood([row.shoppingCartId])
    },
    // 删除已选中的商品
    handleDeleteChoosed () {
      this.deleteShoppingCartGood(
        this.multipleSelection.map(item => {
          return item.shoppingCartId
        })
      )
    },
    // 清空购物车
    clearShoppingCart () {
      this.deleteShoppingCartGood(
        this.dataList.map(item => {
          return item.shoppingCartId
        })
      )
    },
    // 删除购物车信息
    deleteShoppingCartGood (ids = []) {
      if (ids.length === 0) {
        return this.$message.warning('请选择要删除的商品')
      }
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http
        .post(`/front/consumer/shoppingcart/deleteShoppingCart`, ids)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return
          }
          this.getDataList()
          this.getShopCartCount()
          this.bus.$emit('shopCartNum')
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
        })
        .finally(() => {
          this.dataListLoading = false
        })
    },
    // 结算 跳转订单页面
    settlement () {
      if (this.dataListLoading) {
        return
      }
      if (!this.multipleSelection.length) {
        return this.$message.warning(this.$t('message.selectData'))
      }
      let shoppingCartFormList = []
      this.multipleSelection.forEach(item => {
        let row = this.dataList.find(ele => {
          return ele.shoppingCartId === item.shoppingCartId
        })
        if (row) {
          shoppingCartFormList.push({
            goodsSpuId: item.goodsSpuId,
            goodsSkuId: item.goodsSkuId,
            goodsNum: item.goodsNum
          })
        }
      })
      if (shoppingCartFormList.length) {
        this.dataListLoading = true
        // 立即下单校验数量价格相关等
        this.$http
          .post(
            `/front/consumer/shoppingcart/checkCommodityPromotion`,
            shoppingCartFormList.map(item => {
              return {
                commodityId: item.goodsSkuId,
                commodityNum: item.goodsNum
              }
            })
          )
          .then(({ data: res }) => {
            if (res.code !== 0) {
              this.$confirm(res.message, '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {})
              return false
            } else {
              this.$router.push({
                name: 'punchoutSubmitOrder',
                query: {
                  orderSource: '10',
                  shoppingCartFormList: JSON.stringify(shoppingCartFormList)
                }
              })
            }
          })
          .finally(() => {
            this.dataListLoading = false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home_page {
  .tabs {
    margin: 0;
    border-bottom: 3px solid #0064c0;
    .s2b-tab-item {
      padding: 0 20px;
      color: #0064c0;
      background: none;
      height: 48px;
      line-height: 48px;
      margin-left: 0;
    }
    .tab-item-active {
      background: #0064c0;
      color: #fff;
    }
  }
  .shopping-cart {
    width: 100%;
    background: #fff;
    padding: 15px 35px 30px;
    .discount {
      text-decoration: line-through;
      color: #aaaaaa;
    }
    .goodsName {
      color: #1e64a9;
      cursor: pointer;
    }
    .fix {
      display: flex;
      justify-content: space-between;
      height: 50px;
      background-color: #eeeeee;
      .left {
        line-height: 50px;
        flex-shrink: 0;
        .check-all {
          margin-left: 15px;
        }
        span {
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .div1 {
        margin-left: 380px;
        width: 140px;
        .red {
          font-weight: bold;
          color: red;
        }
      }
      .div2 {
        margin-left: 40px;
        width: 150px;
        .red {
          font-weight: bold;
          font-size: 15px;
          color: red;
        }
        .discount {
          text-decoration: line-through;
          color: #aaaaaa;
        }
      }
      .div3 {
        width: 141px;
        margin-left: 20px;
        color: #fff;
        background-color: #1e64a9;
        font-size: 18px;
      }
      .buttonDemand {
        margin-left: 200px;
      }
    }
  }
}
</style>
